export default {
  展览: '展览',
  展览状态: '展览状态',
  历史展览: '历史展览',
  发布记录: '发布记录',
  上传照片: '上传照片',
  已上架产品: '已上架产品',
  展览云图: '展览云图',
  导读简介: '导读简介',
  请输入展览导读简介: '请输入展览导读简介',
  范围标签: '范围标签',
  '请输入展览导读简介,最多可输入1200个字符(600个汉字)': '请输入展览导读简介,最多可输入1200个字符(600个汉字)',
  添加新标签: '添加新标签',
  '内容...': '内容...',
  '距开幕,还有': '距开幕,还有',
  '距闭幕,还有': '距闭幕,还有',
}
